import React, { useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface ReCaptchaProps {
  onChange: (token: string | null) => void;
}

export default function ReCaptcha({ onChange }: ReCaptchaProps) {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

  useEffect(() => {
    if (!siteKey) {
      onChange('bypass-no-sitekey');
    }
  }, [siteKey, onChange]);

  if (!siteKey) {
    return null;
  }

  return (
    <div className="my-3">
      <ReCAPTCHA sitekey={siteKey} onChange={onChange} />
    </div>
  );
}
